import script from "./SocialInbox.vue?vue&type=script&setup=true&lang=ts"
export * from "./SocialInbox.vue?vue&type=script&setup=true&lang=ts"

import "./SocialInbox.vue?vue&type=style&index=0&id=05636262&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05636262"]])

export default __exports__